export default function UserTable({ users, schedules, orders, addresses }) {
  if (!users.length) return <div className="admin-empty"><i className="fa-solid fa-users" /><strong>No users found.</strong><span>Registered customers will appear here.</span></div>;
  const count = (items, uid) => items.filter((item) => item.userId === uid).length;
  return <div className="admin-table-wrap"><table className="admin-table"><thead><tr><th>User</th><th>Mobile</th><th>Addresses</th><th>Schedules</th><th>Orders</th><th>Joined</th></tr></thead><tbody>
    {users.map((user) => <tr key={user.id}>
      <td><strong>{user.name || "Unnamed user"}</strong><small>{user.email || "—"}</small></td>
      <td>{user.mobile || "—"}</td>
      <td>{count(addresses, user.id)}</td>
      <td>{count(schedules, user.id)}</td>
      <td>{count(orders, user.id)}</td>
      <td>{user.createdAt?.toDate ? user.createdAt.toDate().toLocaleDateString("en-IN") : "—"}</td>
    </tr>)}
  </tbody></table></div>;
}
